export default {
      id: "ic_empty-usage",
      viewBox: "0 0 54 60",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_empty",
      toString: function () {
        return this.url;
      }
    }